"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationType = void 0;
var AggregationType;
(function (AggregationType) {
    AggregationType["CountAll"] = "COUNT_ALL";
    AggregationType["ByCaseGroup"] = "BY_CASE_GROUP";
    AggregationType["ByWorkflow"] = "BY_WORKFLOW";
    AggregationType["ByCreditor"] = "BY_CREDITOR";
    AggregationType["ByCaseStatus"] = "BY_CASE_STATUS";
    AggregationType["ByBillingModel"] = "BY_BILLING_MODEL";
    AggregationType["ByBillingAppendixSetup"] = "BY_BILLING_APPENDIX_SETUP";
    AggregationType["ByMigratedWorkflowTaskId"] = "BY_MIGRATED_WORKFLOW_TASK_ID";
})(AggregationType || (exports.AggregationType = AggregationType = {}));
//# sourceMappingURL=aggregations.js.map